class Cookies {
  constructor(banner) {
    this.banner = banner
    this.accept = this.banner.querySelector('.button.accept')
    this.decline = this.banner.querySelector('.button.decline')
    this.consentMode = localStorage.getItem('consentMode')

    if (this.consentMode === null) {
      this.showBanner()
      this.accept.addEventListener('click', this.setConsentMode.bind(this, 'granted'))
      this.decline.addEventListener('click', this.setConsentMode.bind(this, 'denied'))
    } else {
      this.hideBanner()
    }
  }
  setConsentMode(userSelection) {

    const consent = { 
      ad_storage: userSelection,
      ad_user_data: userSelection,
      ad_personalization: userSelection,
      analytics_storage: userSelection,
			personalization_storage: userSelection,
			functionality_storage: userSelection,
			security_storage: userSelection
    }

    gtag('consent', 'update', consent)

    localStorage.setItem('consentMode', JSON.stringify(consent))

		if (userSelection == 'granted') {
			gtag('event', 'cookies_granted')
		} else {
			gtag('event', 'cookies_declined')
		}

    this.hideBanner()
  }
  showBanner() {
    this.banner.classList.add('visible')
  }
  hideBanner() {
    this.banner.classList.remove('visible')
  }
}

export const cookieBanner = () => {
	const banner = document.querySelector('.cookies')

	if (banner) {
		new Cookies(banner)
	}
}

export default () => {}